module.exports = __webpack_public_path__ + "img/nasi-rames.b779cc01.jpg";